export default __webpack_public_path__ + "static/media/goki.0a0c9e91.png";